import { createContext, useContext, useEffect, useState, useCallback } from "react";

const SettingsContext = createContext(null);

export const dataSaverEnabled = () => localStorage.getItem("ntv_data_saver") === "1";

export function SettingsProvider({ children }) {
  const [dataSaver, setDataSaverState] = useState(dataSaverEnabled());
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);

  const setDataSaver = useCallback((v) => {
    localStorage.setItem("ntv_data_saver", v ? "1" : "0");
    setDataSaverState(v);
    window.dispatchEvent(new Event("ntv-datasaver-change"));
  }, []);

  return (
    <SettingsContext.Provider value={{ dataSaver, setDataSaver, online }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
